/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consult_Purchase_TitleInputs */

const en_consult_purchase_title = /** @type {(inputs: Consult_Purchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request an offer`)
};

const id_consult_purchase_title = /** @type {(inputs: Consult_Purchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minta penawaran`)
};

/**
* | output |
* | --- |
* | "Request an offer" |
*
* @param {Consult_Purchase_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_purchase_title = /** @type {((inputs?: Consult_Purchase_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_Purchase_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_purchase_title(inputs)
	return en_consult_purchase_title(inputs)
});